import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {SymbolsService} from '../../services/symbols.service';
import {QedMulticast} from '../../models/qedMulticast';
import {QedSymbolsInfo} from '../../models/qedSymbolsInfo';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../base-client.component';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-qrd-product-information',
  templateUrl: './qrd-product-information.component.html',
  styleUrls: ['./qrd-product-information.component.scss'],
  host: {class: 'sym-page'}
})
export class QrdProductInformationComponent extends BaseClientComponent implements OnInit {

  qrdMulticastArray: QedMulticast[];
  productList = [];
  cols = [];
  qrdSymbolsInfo: QedSymbolsInfo;
  loading = true;
  public startDates: string[];
  qrdSymbolsInfoData: any;
  noData = false;

  constructor(private utilsService: UtilsService,
              public authenticationService: AuthenticationService,
              private symbolsService: SymbolsService) {
    super();
    this.cols = [
      {field: 'product.name', header: 'QRD/QPD Product', sortDisabled: false, class: ''},
      {field: 'pop', header: 'POP', sortDisabled: false, class: ''},
      {field: 'qrdl1', header: 'Available as QRD L1', sortDisabled: true, class: ''},
      {field: 'qrdl3', header: 'Available as QRD L3', sortDisabled: true, class: ''},
      {field: 'qpdl3', header: 'Available as QPD L3', sortDisabled: true, class: ''},
    ];
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getQrdSymbolStartDate();
    });
    this.subscriptions.push(response$);
  }

  private getQrdSymbolStartDate() {
    this.symbolsService.getSymbolStartDates('qrd').subscribe({
          next: qrdSymbolsStartDates => {
            this.startDates = qrdSymbolsStartDates;
            this.getQrdSymbolsInfo();
          }, error: () => {
            this.utilsService.unlockUi();
            this.redirectionToNotFound();
          }
        }
    );
  }

  private getQrdSymbolsInfo() {
    this.symbolsService.getQrdSymbolInfo().subscribe({
          next: qrdSymbolsInfo => {
            if (qrdSymbolsInfo.length === 1) {
              this.qrdSymbolsInfo = qrdSymbolsInfo[0];
              this.qrdSymbolsInfoData = JSON.parse(this.qrdSymbolsInfo.data);
              this.getQrdMulticastList();
            } else {
              this.utilsService.unlockUi();
              this.noData = true;
            }
          }, error: () => {
            this.utilsService.unlockUi();
            this.redirectionToNotFound();
          }
        }
    );
  }

  private getQrdMulticastList() {
    if (this.startDates && this.startDates[0]) {
      const date = this.startDates[0];
      forkJoin({
        list: this.symbolsService.getMulticastList('qrd', date),
        details: this.symbolsService.getMulticastDetailsList('qrd', date)
      }).subscribe({
        next: ({ list, details }) => {
          this.qrdMulticastArray = list.map(m => ({
            ...m,
            qedSymbolName: details[m.id]?.qedSymbolName ?? null,
            product: details[m.id]?.product ?? null
          }));
          this.createProductNames();
          this.loading = false;
          this.utilsService.unlockUi();
        },
        error: () => {
          this.utilsService.unlockUi();
          this.redirectionToNotFound();
        }
      });
    } else {
      this.utilsService.unlockUi();
      this.redirectionToNotFound();
    }
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  private createProductNames() {
    const list = this.qrdMulticastArray
        .filter(multicast => multicast.product ? !!multicast.product.name : false)
        .map(qedMulticast => qedMulticast.product)
        .sort();
    for (const cpt in list) {
      if (this.productList.filter(prod => prod.name === list[cpt].name).length === 0) {
        this.productList.push(list[cpt]);
      }
    }
    this.productList.sort((a, b) => a.name < b.name ? -1 : 1);
  }

  createPopListForProduct(product) {
    let list = [];
    const popList = [];
    list = this.qrdMulticastArray
        .filter(qedMulticast => qedMulticast.product && product && qedMulticast.product.name === product.name)
        .map(qedMulticast => qedMulticast.popName)
        .sort();
    for (const cpt in list) {
      if (popList.filter(uniqPop => uniqPop === list[cpt]).length === 0) {
        popList.push(list[cpt]);
      }
    }
    return popList;
  }

  getConnectivityByProduct(productId) {
    const connectivity = [];
    const multicasts = this.getMulticastByProduct(productId);
    for (const mcast of multicasts) {
      let isQrdL1 = false;
      let isQrdL3 = false;
      let isQpdL3 = false;
      if (!mcast.isProtected && mcast.connectivity.includes('layer1') !== false) {
        isQrdL1 = true;
      }
      if (!mcast.isProtected && mcast.connectivity.includes('layer3') !== false) {
        isQrdL3 = true;
      }
      if (mcast.isProtected && mcast.connectivity.includes('layer3') !== false) {
        isQpdL3 = true;
      }
      const popName = mcast.popName;
      connectivity[popName] = {
        QRDL1: !!connectivity[popName] && !!connectivity[popName]['QRDL1'] ? true : isQrdL1,
        QRDL3: !!connectivity[popName] && !!connectivity[popName]['QRDL3'] ? true : isQrdL3,
        QPDL3: !!connectivity[popName] && !!connectivity[popName]['QPDL3'] ? true : isQpdL3,
      };
    }

    return connectivity;
  }

  getMulticastByProduct(productId) {
    return this.qrdMulticastArray.filter(mcast => mcast.product && mcast.product.id === productId);
  }

  thereIsDataToDisplay(productList: any[]) {
    return productList.length > 0;
  }
}
